import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  Avatar,
  Button,
  Row,
  Col,
  Dropdown,
  Space,
  Modal,
  Drawer,
} from "antd";
import {
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import { getLeadNotessListAPI, deleteLeadNoteByIdAPI } from "../LeadsAPI";
import { getEmployeeAPI } from "CommonComponents/Lookup/LookupAPI";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import FormType from "features/Enums/FormType";
import LeadNoteForm from "./LeadNoteForm";

const { Text } = Typography;

const LeadNoteItem = () => {
  const dispatch = useDispatch();
  const { leadId } = useParams();
  const intl = useIntl();

  const employeeList = useSelector((state) => state.lookup.employesList);
  const leadNotesList = useSelector((state) => state.leads.leadNoteList);
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadNotes"
  )?.id;
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  useEffect(() => {
    dispatch(getEmployeeAPI());
    dispatch(getLeadNotessListAPI(leadId));
  }, [dispatch, leadId]);
  const getEmployeeNameById = (id) => {
    const emp = employeeList.find((e) => e.id === id);
    return emp ? `${emp.firstName} ${emp.lastName}` : "Unknown";
  };
  const openDrawer = (note = null) => {
    setSelectedNote(note);
    setDrawerVisible(true);
  };
  const closeDrawer = () => {
    setSelectedNote(null);
    setDrawerVisible(false);
  };
  const handleDelete = (id) => {
    Modal.confirm({
      title: intl.formatMessage({ id: "LeadMail.DeleteConfirm" }),
      okText: intl.formatMessage({ id: "Common.Yes" }),
      cancelText: intl.formatMessage({ id: "Common.No" }),
      okType: "danger",
      onOk: () => dispatch(deleteLeadNoteByIdAPI(id, leadId)),
    });
  };
  const dropdownItems = (note) => [
    {
      key: "edit",
      label: (
        <span onClick={() => openDrawer(note)}>
          <EditOutlined /> <FormattedMessage id="Common.Edit" />
        </span>
      ),
    },
    {
      key: "delete",
      label: (
        <span onClick={() => handleDelete(note.id)}>
          <DeleteOutlined /> <FormattedMessage id="Common.Delete" />
        </span>
      ),
    },
  ];

  return (
    <>
      <Card
        size="small"
        title="Notes"
        extra={
          <Button type="link" onClick={() => openDrawer()}>
            <PlusCircleOutlined /> <FormattedMessage id="LeadCall.AddNew" />
          </Button>
        }
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          {leadNotesList?.length > 0 ? (
            (() => {
              const note = leadNotesList[0];
              return (
                <Card key={note.id} className="activitytab">
                  <div className="activitytab-dropdown">
                    <Dropdown menu={{ items: dropdownItems(note) }}>
                      <Button icon={<MoreOutlined />} />
                    </Dropdown>
                  </div>
                  <Row gutter={12} align="middle">
                    <Col>
                      <Avatar size={36} icon={<UserOutlined />} />
                    </Col>
                    <Col flex="auto">
                      <Text strong>{getEmployeeNameById(note.createdBy)}</Text>
                      <br />
                      <Text type="secondary">
                        {dayjs(note.createdDate).format("DD MMM YYYY, hh:mm a")}
                      </Text>
                    </Col>
                  </Row>
                  <div style={{ marginTop: 8 }}>
                    <Text strong>{note.title}</Text>
                    <p>{note.note}</p>
                  </div>
                  <AttachmentComponent
                    identifier={formTypeId}
                    currentId={note.id}
                    isPreview={true}
                    getattachments={true}
                  />
                </Card>
              );
            })()
          ) : (
            <Text type="secondary">
              <FormattedMessage id="NoData" />
            </Text>
          )}
        </Space>
      </Card>

      <LeadNoteForm
        note={selectedNote}
        onClose={closeDrawer}
        drawerVisible={drawerVisible}
      />
    </>
  );
};

export default LeadNoteItem;
